// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FmIo","buttons":"Footer_buttons__3cqJT"};